import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from '../../../../withRouter'
import { isNumber } from 'lodash'
import { colors } from '@lmc/common/constants'
import { Icon, ProfilePicture } from '../../../../components/generic'
import { history } from '../../../../store'

export class ResidentStockItem extends React.Component {
  redirect = () => {
    history.push(`/residents/${this.props.resident.id}/emar/stock`)
  }

  renderMedication = (row, i) => {
    const name = row.customName || row.medication.name
    if (!name) return null
    const { stockQuantityType } = row
    const { amount1, amount2 } = row.stockLog
    const currentStock = isNumber(amount1) ? amount1 : amount2

    let label =
      currentStock === 0
        ? `Out of stock`
        : `${currentStock || ''} ${stockQuantityType || ''} left`

    return (
      <div key={name} style={styles.greyText}>
        <span style={styles.alertText}>{label}</span> • {name}
      </div>
    )
  }

  renderTopRightIcon = () => (
    <div style={styles.iconContainer}>
      <span style={styles.count}>{this.props.emarResidentMeds.length}</span>
      <Icon fill={colors.red} name="incident" style={styles.icon} />
    </div>
  )

  render() {
    const { emarResidentMeds, resident, router } = this.props
    if (
      !emarResidentMeds ||
      !emarResidentMeds.length ||
      !resident ||
      !resident.name ||
      !router
    )
      return null

    return (
      <div className="lmc-list-item" style={styles.wrapper}>
        <div
          id="stock-levels-container"
          className="lmc-list-item-link-container"
          onClick={this.redirect}
          style={styles.mainInfoContainer}
        >
          <ProfilePicture
            url={resident.picture}
            style={styles.profilePicture}
            type="small"
          />
          <div
            className="lmc-list-item-parent-link"
            style={styles.residentNameContainer}
          >
            <span className="lmc-list-item-link" style={styles.residentName}>
              {resident?.preferredName || resident.name.first}{' '}
              {resident.name.last}
            </span>
            <div style={styles.adlsContainer}>
              {emarResidentMeds.map(this.renderMedication)}
            </div>
          </div>
        </div>
        <div>{this.renderTopRightIcon()}</div>
      </div>
    )
  }
}

const styles = {
  greyText: {
    color: colors.darkgrey,
  },
  icon: {
    marginLeft: 12,
  },
  iconContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  mainInfoContainer: {
    cursor: 'pointer',
    display: 'flex',
    flex: 1,
    minWidth: 200,
    paddingBottom: 2,
  },
  alertText: {
    color: colors.red,
  },
  residentNameContainer: {
    overflow: 'hidden',
    paddingRight: 12,
    textOverflow: 'ellipsis',
  },
  profilePicture: {
    border: 'none',
    flexShrink: 0,
    margin: '0px 12px 0px 0px',
  },
  residentName: {
    fontSize: 16,
    fontWeight: 'bold',
    overflow: 'hidden',
    minWidth: 0,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  wrapper: {
    display: 'flex',
    minWidth: 250,
    margin: 0,
    padding: '8px 13px',
    marginBottom: 12,
  },
}

ResidentStockItem.propTypes = {
  router: PropTypes.object.isRequired,
  resident: PropTypes.object.isRequired,
  emarResidentMeds: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default withRouter(ResidentStockItem)
